import { API_BASE_URL } from "./env";

export const API_ENDPOINTS = {
    getParcelData: `${API_BASE_URL}/api/land-parcels/`,
    getParcelViewport: `${API_BASE_URL}/api/parcels/viewport/`,
    getLandParcelsWeighted: `${API_BASE_URL}/api/land-parcels-weighted/`,
    parcelEngagement: `${API_BASE_URL}/api/parcel-engagement/`,
    getSCAQMDJurisdiction: `${API_BASE_URL}/api/scaqmd-jurisdiction/`,
    getSCAQMDSourceReceptorAreas: `${API_BASE_URL}/api/scaqmd-source-receptor-areas/`,
    getCounties: `${API_BASE_URL}/api/counties/`,
    getMdhdInfrastructure: `${API_BASE_URL}/api/calstart-mdhd-infrastructure/`,
    getWarehouses: `${API_BASE_URL}/api/warehouses/`,

    // Heatmap API
    getHeatmapData: `${API_BASE_URL}/api/heatmap/data/`,
    getHeatmapStats: `${API_BASE_URL}/api/heatmap/stats/`,
    
    // Disadvantaged Communities API
    getDisadvantagedCommunities: `${API_BASE_URL}/api/disadvantaged-communities/`,
    getDisadvantagedCommunitiesConsolidated: `${API_BASE_URL}/api/disadvantaged-communities-consolidated/`,
    getCalEnviroScreen40: `${API_BASE_URL}/api/calenviroscreen-40/`,

    // Truck Stop Data API
    getIntermodalTerminals: `${API_BASE_URL}/api/intermodal-terminals/`,
    getServiceCenters: `${API_BASE_URL}/api/service-centers/`,

    // Circuit API
    getCircuits: `${API_BASE_URL}/api/circuits/`,
    getCircuitContours: `${API_BASE_URL}/api/circuit-capacity-contours/`,
    getPowerSubstations: `${API_BASE_URL}/api/power-substations/`,

    // Vector Tiles (Charging Station Module)
    vectorTiles: {
      circuitContours: `${API_BASE_URL}/api/tiles/circuit-contours/{z}/{x}/{y}.pbf?v=2026-09-10-curyr`,
      // Bump the `v` query param whenever the tile's property schema or values
      // change so browsers refetch instead of serving 24h-cached tiles (the tile
      // now carries alc_multiyear, current-year capacity_kw, and substation
      // capacity). Keep this in sync with CombinedCircuitsTileView key_prefix.
      circuitsCombined: `${API_BASE_URL}/api/tiles/circuits-combined/{z}/{x}/{y}.pbf?v=2026-09-04-gna-base`,
      heatmapHexagons: `${API_BASE_URL}/api/tiles/heatmap-hexagons/{z}/{x}/{y}.pbf`,
      parcels: `${API_BASE_URL}/api/tiles/parcels/{z}/{x}/{y}.pbf`,
      parcelPoints: `${API_BASE_URL}/api/tiles/parcel-points/{z}/{x}/{y}.pbf`
    },

    // Traffic Points API 
    getTrafficData: `${API_BASE_URL}/api/traffic-data/`,

    // Utility Loadmap API
    getUtilityLoadmap: `${API_BASE_URL}/api/utilities-loadmap/`,
}